const Privacy = () => {
  return (
    <div className="policy privacy container">
      <h1>Privacy Policy</h1>
      <p>
        Rexla Global (“<b>Rexla</b>,” “<b>us</b>,” “<b>we</b>,” or “<b>our</b>”)
        provides the Rexla Hub and associated products (located at Rexla.com) to
        allow users to onboard and learn about Digital/Crypto Assets, obtain
        education on the space and act as a hub for individuals to interact with
        blockchain technology. This includes mobile applications and the
        blockchain currency management software that is downloadable from our
        website (the “<b>Rexla Wallet</b>”), and the Digi Dimes Rewards Program
        (“<b>Rewards Program</b>”), collectively the “Services”. This Privacy
        Policy is to provide you with information on use of your personal data
        in accordance with applicable data privacy laws. This Privacy Policy is
        designed to help you understand how we collect, use, process, and share
        your personal information, and to help you understand and exercise your
        privacy rights. For the purposes of this Privacy Policy, “
        <b>Personal Data</b>” means information that relates to an identified or
        identifiable natural person.
      </p>

      <h4>1. SCOPE</h4>
      <p>
        This Privacy Policy applies to personal information processed by us,
        including on our websites and other online or offline offerings. Rexla
        Global is the controller for the personal information we process, unless
        otherwise stated. For information on how to contact us, please refer to
        "Contact Us" below.
      </p>
      <p>
        <b>NOTICE TO EUROPEAN USER:</b> Please see the below Rights Of Users
        from the European Economic Area (“EEA”) and United Kingdom (“UK”)
        section for additional information for individuals located in the
        European Economic Area or United Kingdom (which we refer to as “Europe”,
        and “European” accordingly).
      </p>

      <h4>2. PERSONAL INFORMATION WE COLLECT</h4>
      <p>
        The categories of personal information we collect depend on how you
        interact with us, our Services, and the requirements of applicable law.
        We collect information that you provide to us, information we obtain
        automatically when you use our Services, and information from other
        sources such as third-party services and organizations, as described
        below.
      </p>
      <h5>A. Information You Provide to Us Directly</h5>
      <p>
        We may collect the following personal information that you provide to
        us.
      </p>
      <ul>
        <li>
          <b>Contact information.</b> Through your engagement with our Services,
          you may provide us with your first and last name, email address, phone
          number or other information.
        </li>
        <li>
          <b>Crypto Wallet information.</b> To interact with our various
          services and partners, you will need to log in with an existing
          cryptocurrency wallet or use the Rexla Wallet. Interactions with the
          Rexla Wallet on our site are subject to this Privacy Policy. As the
          Rexla Wallet is a non-custodial crypto asset software wallet, we do
          not require you to provide your Personal Data to us to use the Rexla
          Wallet. . Information We may collect aggregated and anonymized data
          from use of the Rexla wallet in order to make improvements to the
          software. Note that your interactions with third-party wallet services
          are subject to each wallet’s respective privacy policy, not this
          Privacy Policy.
        </li>
        <li>
          <b>KYC.</b> Interactions with the Rexla suite of products do however
          include an element of “KYC” (Know your customer) This is to ensure
          that individuals interacting with our services are in jurisdictions
          that permit interaction, and to avoid minors utilising services. KYC
          data is held securely and in line with our data retention policy.
        </li>
        <li>
          <b>Transactional information.</b> When completing a transaction using
          the Services, you provide the blockchain transaction history and
          information relating to or needed to complete your purchases or sales
          on or through the Service.
        </li>
        <li>
          <b>Financial information.</b> When using the Rexla Wallet, you provide
          us with information such as your virtual currency or wallet account
          balances and other associated information, stored value accounts,
          royalties, fees, sales prices, sell-through data, and associated
          details.
        </li>
        <li>
          <b>Rewards Program.</b> In order to administer our Rewards Program, we
          may collect information about your use of the Services, including the
          Rexla Wallet, your transactions on our platform, and your interaction
          with partner services. Your rewards related activity may also be
          reflected in your Rexla Wallet should you elect to download the
          software and connect it to our platform.
        </li>
        <li>
          <b>Your Communications with Us.</b> We may collect personal
          information, such as email address, phone number, or mailing address
          when you request information about our Services, register for our
          newsletter or blog, request customer or technical support, apply for a
          job, or otherwise communicate with us.
        </li>
        <li>
          <b>Surveys.</b> We may contact you to participate in surveys. If you
          decide to participate, you may be asked to provide certain
          information, which may include personal information.
        </li>
        <li>
          <b>Interactive Features.</b> We and others who use our Services may
          collect personal information that you submit or make available through
          our interactive features (e.g., messaging and chat features,
          commenting functionalities, forums, blogs, and social media pages,
          including those on X, Discord, Medium, Youtube, Twitch, TikTok and
          Spotify). Any information you provide using the public sharing
          features of the Services (referred to herein as “User Content”) will
          be considered “public,” unless otherwise required by applicable law,
          and is not subject to the privacy protections referenced herein.
          Please exercise caution before revealing any information that may
          identify you in the real world to other users.
        </li>
        <li>
          <b>Contests.</b> We may collect personal information you provide for
          any contests that we offer. If you participate in a promotion, or
          giveaway through the Service, we may ask you for your Contact Data to
          notify you if you win or not, to verify your identity, to determine
          your eligibility, and/or to send you prizes. These promotions and
          giveaways are voluntary. We recommend that you read the rules and
          other relevant information for each contest that you enter. In some
          jurisdictions, we are required to publicly share information of
          contest winners.
        </li>
        <li>
          <b>Conferences, Trade Shows, and Other Events.</b> We may collect
          personal information from individuals when we attend or host
          conferences, trade shows, and other events.
        </li>
        <li>
          <b>Business Development and Strategic Partnerships.</b> We may collect
          personal information from individuals and third parties to assess and
          pursue potential business opportunities.
        </li>
        <li>
          <b>Job Applications.</b> We may post job openings and opportunities on
          our Services. If you reply to one of these postings by submitting your
          application, CV and/or cover letter to us, we will collect and use
          this information to assess your qualifications.
        </li>
        <li>
          <b>No sensitive personal information.</b> Please do not provide us
          with any sensitive personal information (e.g., social security
          numbers, information related to racial or ethnic origin, political
          opinions, religion or other beliefs, health, biometrics or genetic
          characteristics, criminal background or trade union membership) on or
          through the Service, or otherwise to us. If you provide us with any
          sensitive personal information to us when you use the Service, you
          must consent to our processing and use of such sensitive personal
          information in accordance with this Privacy Policy. If you do not
          consent to our processing and use of such sensitive personal
          information, you must not submit such sensitive personal information
          through our Service.
        </li>
      </ul>

      <h5>B. Information Collected Automatically</h5>
      <p>
        We may collect personal information automatically when you use our
        Services:
      </p>
      <ul>
        <li>
          <b>Automatic Data Collection.</b> We may collect certain information
          automatically when you use our Services, such as your Internet
          protocol (IP) address, user settings, MAC address, cookie identifiers,
          mobile carrier, mobile advertising and other unique identifiers,
          browser or device information, location information (including
          approximate location derived from IP address), and Internet service
          provider. We may also automatically collect information regarding your
          use of our Services, such as pages that you visit before, during and
          after using our Services, information about the links you click, the
          types of content you interact with, the frequency and duration of your
          activities, and other information about how you use our Services. We
          also track the floor price, volume, and average prices for all NFT
          collections hosted on our platform over time. When performing an
          exchange through a third-party API provider, we log information such
          as the wallet addresses and the transaction IDs involved.
        </li>
        <li>
          <b>Cookies, Pixel Tags/Web Beacons, and Other Technologies.</b> We, as
          well as third parties that provide content, advertising, or other
          functionality on our Services, may use cookies, pixel tags, and other
          technologies ("Technologies") to automatically collect information
          through your use of our Services.
          <p>
            o Cookies. Cookies are small text files placed in device browsers
            that store preferences and facilitate and enhance your experience.
            For further information, visit allaboutcookies.org.
          </p>
          <p>
            o Pixel Tags/Web Beacons. A pixel tag (also known as a web beacon)
            is a piece of code embedded in our Services that collects
            information about engagement on our Services. The use of a pixel tag
            allows us to record, for example, that a user has visited a
            particular web page or clicked on a particular advertisement. We may
            also include web beacons in e-mails to understand whether messages
            have been opened, acted on, or forwarded.
          </p>
        </li>
      </ul>

      <h6>
        Our uses of these Technologies fall into the following general
        categories:
      </h6>
      <ul>
        <li>
          <b>Operationally Necessary.</b> This includes Technologies that allow
          you access to our Services, applications, and tools that are required
          to identify irregular website behavior, prevent fraudulent activity,
          improve security, or allow you to make use of our functionality;
        </li>
        <li>
          <b>Performance-Related.</b> We may use Technologies to assess the
          performance of our Services, including as part of our analytic
          practices to help us understand how individuals use our Services (see
          Analytics below);
        </li>
        <li>
          <b>Functionality-Related.</b> We may use Technologies that allow us to
          offer you enhanced functionality when accessing or using our Services.
          This may include identifying you when you sign into our Services or
          keeping track of your specified preferences, interests, or past items
          viewed; and
        </li>
        <li>
          <b>Advertising- or Targeting-Related.</b> We may use first party or
          third-party Technologies to deliver content, including ads relevant to
          your interests, on our Services or on third-party websites.
        </li>
        <li>
          <b>Analytics.</b> We may use Technologies and other third-party tools
          to process analytics information on our Services. Some of our
          analytics partners include{" "}
          <a
            href="https://policies.google.com/technologies/partner-sites"
            target="_blank"
            rel="noreffer"
          >
            Google Analytics
          </a>
          ,{" "}
          <a
            href="https://www.rudderstack.com/privacy-policy/"
            target="_blank"
            rel="noreffer"
          >
            RudderStack
          </a>
          ,{" "}
          <a
            href="https://www.dynamic.xyz/privacy-policy"
            target="_blank"
            rel="noreffer"
          >
            Dynamic
          </a>
          ,{" "}
          <a
            href="https://www.databricks.com/legal/privacynotice"
            target="_blank"
            rel="noreffer"
          >
            Databricks
          </a>
          and{" "}
          <a
            href="https://www.datadoghq.com/legal/privacy/"
            target="_blank"
            rel="noreffer"
          >
            DataDog
          </a>
          . This allows us to process usage data to better understand how our
          website and web-related Services are used. This enables us to
          continually improve our website, making it relevant to your interests
          and needs. This may involve personal data, such as cookie and other
          device identifiers. For more information, please visit Google
          Analytics’ Privacy Policy, RudderStack Privacy Policy, Dynamic Privacy
          Policy, Databricks Privacy Notice and DataDog’s Privacy Policy.{" "}
        </li>
        <li>
          <b>Social Media Platforms.</b> Our Services may contain social media
          buttons, such as Xyra,X, Discord, Medium, and Spotify, which might
          include widgets such as the “share this” button or other interactive
          mini programs). These features may collect your IP address and which
          page you are visiting on our Services, and may set a cookie to enable
          the feature to function properly. Your interactions with these
          platforms are governed by the privacy policy of the company providing
          it.
        </li>
      </ul>
      <p>
        See “Your Privacy Choices and Rights” below to understand your choices
        regarding these Technologies.
      </p>

      <h5>C. Information Collected from Other Sources</h5>
      <p>
        We may obtain information about you from other sources, including
        through third-party services, marketplaces, business partners and
        organizations. For example, if you access our Services through a
        third-party application, such as an app store, a third-party login
        service, or a social networking site, we may collect information about
        you from that third-party application that you have made available via
        your privacy settings in order to provide our services. We may also
        collect information that you provide to one of our business partners in
        connection with a contest.
      </p>
      <p>
        <b>Referrals and Sharing Features.</b> Our Services may offer various
        tools and functionalities that allow you to provide information about
        your friends through our referral service; third parties may also use
        these services to upload information about you. Our referral services
        may also allow you to forward or share certain content with a friend or
        colleague, such as an email inviting your friend to use our Services.
        Please only share with us contact information of people with whom you
        have a relationship (e.g., relative, friend, neighbour, or co-worker).
      </p>

      <h4>3. HOW WE USE YOUR INFORMATION</h4>
      <p>
        We use your information for a variety of business purposes, including to
        provide our Services, for administrative purposes, and to market our
        products and Services, as described below. For users in the EEA and UK,
        the legal basis for collection of this information is to provide you our
        Services and make it possible for you to use our Services.
      </p>
      <h5>A. Provide Our Services</h5>
      <p>
        We use your information to fulfill our contract with you and provide you
        with our Services, such as:
      </p>
      <ul>
        <li>
          Managing your information and accounts, including to connect a
          cryptocurrency wallet and authenticate your user credentials;
        </li>
        <li>
          Providing access to certain areas, functionalities, and features of
          our Services;
        </li>
        <li>Answering requests for customer or technical support;</li>
        <li>
          Communicating with you about your account, activities on our Services,
          and policy changes;
        </li>
        <li>
          Processing your financial information and other payment methods for
          products or Services purchased or downloaded;
        </li>
        <li>Offering our Rewards Program</li>
        <li>
          Processing applications if you apply for a job we post on our
          Services; and allowing you to register for events.
        </li>
      </ul>

      <h5>B. Administrative Purposes</h5>
      <p>
        We use your information for our legitimate interests, or to comply with
        our legal obligations, such as:
      </p>
      <ul>
        <li>
          Direct marketing, research and development (including marketing
          research), network and information security, and fraud prevention;
        </li>
        <li>
          Detecting security incidents, protecting against malicious, deceptive,
          fraudulent or illegal activity, and prosecuting those responsible for
          that activity;
        </li>
        <li>Measuring interest and engagement in our Services;</li>
        <li>
          Short-term, transient use, such as contextual customization of ads;
        </li>
        <li>Improving, upgrading, or enhancing our Services;</li>
        <li>Developing new products and Services;</li>
        <li>Ensuring internal quality control and safety;</li>
        <li>
          Authenticating and verifying individual identities, including requests
          to exercise your rights under this policy;
        </li>
        <li>Debugging to identify and repair errors with our Services;</li>
        <li>
          Auditing relating to interactions, transactions, and other compliance
          activities;
        </li>
        <li>
          Sharing information with third parties as needed to provide the
          Services;
        </li>
        <li>Enforcing our agreements and policies; </li>
        <li>
          Other uses as required to comply with our legal obligations and
          requests, such as to respond to subpoenas or requests from government
          authorities; protect our, your or others’ rights or privacy; and
          prevent, identify, investigate and deter fraudulent, harmful,
          unauthorized, unethical or illegal activity, including cyberattacks
          and identity theft.
        </li>
      </ul>

      <h5>C. Marketing and Advertising our Products and Services</h5>
      <p>
        We may use personal information to tailor and provide you with content
        and advertisements. We may provide you with these materials as permitted
        by applicable law.
      </p>
      <p>
        Some of the ways we market to you include email campaigns, custom
        audiences advertising, and “interest-based” or “personalized
        advertising,” including through cross-device tracking.
      </p>
      <p>
        If you have any questions about our marketing practices, or if you would
        like to opt out of the use of your personal information for marketing
        purposes, you may contact us at any time as set forth in “Contact Us”
        below.
      </p>

      <h5>D. Other Purposes</h5>
      <p>
        We also use your information for other purposes as requested by you or
        as permitted by applicable law.
      </p>
      <ul>
        <li>
          <b>Consent.</b> We may use personal information for other purposes
          that are clearly disclosed to you at the time you provide personal
          information or with your consent.
        </li>
        <li>
          <b>De-identified and Aggregated Information.</b> We may use personal
          information and other information about you to create de-identified
          and/or aggregated information, such as de-identified demographic
          information, information about the device from which you access our
          Services, or other analyses we create. If we create or receive
          personal data that has been de-identified or aggregated, we will not
          attempt to reidentify it, except to comply with applicable law.
        </li>
      </ul>
      <h6>Initial KYC</h6>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Data Type</th>
            <th>Data Subject and Source</th>
            <th>Legal Basis</th>
            <th>Purpose</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Govt. Issued ID</td>
            <td>Customers</td>
            <td>Consent, Legal Obligation</td>
            <td>KYC to prevent malicious actors</td>
          </tr>
        </tbody>
      </table>

      <h6>Rexla Hub/Wallet</h6>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Data Type</th>
            <th>Data Subject and Source</th>
            <th>Legal Basis</th>
            <th>Purpose</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Email Address</td>
            <td>Customers</td>
            <td>Consent</td>
            <td>Marketing and user engagement</td>
          </tr>
          <tr>
            <td>Social Media Username</td>
            <td>Customers</td>
            <td>Consent</td>
            <td>User verification</td>
          </tr>
          <tr>
            <td>IP Address</td>
            <td>Customers</td>
            <td>Consent Legal Obligation</td>
            <td>To comply with legal obligations.</td>
          </tr>
        </tbody>
      </table>

      <h6>Blog/Marketing</h6>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Data Type</th>
            <th>Data Subject and Source</th>
            <th>Legal Basis</th>
            <th>Purpose</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Email Address; IP address, Device Information</td>
            <td>Customers</td>
            <td>Consent</td>
            <td>Marketing and user engagement</td>
          </tr>
        </tbody>
      </table>

      <h4>4. HOW WE DISCLOSE YOUR INFORMATION</h4>
      <p>
        We disclose your information to third parties for a variety of business
        purposes, including to provide our Services, to protect us or others, or
        in the event of a major business transaction such as a merger, sale, or
        asset transfer, as described below.
      </p>
      <h5>A. Disclosures to Provide our Services</h5>
      <ul>
        <li>
          <b>Service Providers.</b> We may share your personal information with
          our third-party service providers who use that information to help us
          provide our Services. This includes service providers that provide us
          with IT support, user authentication and management support, hosting,
          payment processing, customer service, and related services.
          Additionally, a service provider may use your personal data where this
          is necessary for compliance with a legal obligation to which it is
          directly subject. The service provider, in respect of this specific
          use of personal data, may be deemed to be acting as a data controller.
        </li>
        <li>
          <b>Business Partners and Collections.</b> We may share your personal
          information with business partners to provide you with a product or
          service you have requested, or with NFT creators or collections listed
          on our platform that may directly offer you rewards or benefits in
          connection with your purchases. We may also share your personal
          information to business partners with whom we jointly offer products
          or services.
        </li>
        <li>
          <b>Other Users/Website Visitors.</b> As described above in “Personal
          Information We Collect,” our Services allow you to share your profile,
          and/or User Content with other users/publicly, including to those who
          do not use our Services.
        </li>
        <li>
          <b>APIs/SDKs.</b> We may use third-party Application Program
          Interfaces (“APIs”) and Software Development Kits (“SDKs”) as part of
          the functionality of our Services. For more information about our use
          of APIs and SDKs, please contact us as set forth in “Contact Us”
          below.
        </li>
        <li>
          <b>Affiliates and Delegates.</b> Our affiliates and delegates may
          process your personal data on our behalf, including with our banks,
          accountants, auditors and lawyers which may be data controllers in
          their own right.
        </li>
      </ul>
      <h5>B. Disclosures to Protect Us or Others</h5>
      <p>
        We may access, preserve, and disclose any information we store
        associated with you to external parties if we, in good faith, believe
        doing so is required or appropriate to: comply with law enforcement or
        national security requests and legal process, such as a court order or
        subpoena; protect your, our, or others’ rights, property, or safety;
        enforce our policies or contracts; collect amounts owed to us; or assist
        with an investigation or prosecution of suspected or actual illegal
        activity.
      </p>
      <p>
        In certain circumstances we may be legally obliged to share your
        personal data and other financial information with relevant regulatory
        authorities in certain jurisdictions. They, in turn, may exchange this
        information with foreign authorities, including tax authorities and
        other applicable regulatory authorities. In exceptional circumstances,
        we will share your Personal Data with regulatory, prosecuting and other
        governmental agencies or departments, and parties to litigation (whether
        pending or threatened) in any country or territory.
      </p>
      <h5>
        C. Disclosure in the Event of Merger, Sale, or Other Asset Transfers
      </h5>
      <p>
        If we are involved in a merger, acquisition, financing due diligence,
        reorganization, bankruptcy, receivership, purchase or sale of assets, or
        transition of service to another provider, your information may be sold
        or transferred as part of such a transaction, as permitted by law and/or
        contract.
      </p>

      <h4>5. YOUR PRIVACY CHOICES AND RIGHTS</h4>
      <p>
        <b>Your Privacy Choices.</b> The privacy choices you may have about your
        personal information are determined by applicable law and are described
        below.
      </p>

      <ul>
        <li>
          <b>Email Communications.</b> If you receive an unwanted email from us,
          you can use the unsubscribe link found at the bottom of the email to
          opt out of receiving future emails. Note that you will continue to
          receive transaction-related emails regarding products or Services you
          have requested. We may also send you certain non-promotional
          communications regarding us and our Services, and you will not be able
          to opt out of those communications (e.g., communications regarding our
          Services or updates to our Terms or this Privacy Policy).
        </li>
        <li>
          <b>“Do Not Track.”</b> Do Not Track <b>(“DNT”)</b> is a privacy
          preference that users can set in certain web browsers. Please note
          that we do not respond to or honor DNT signals or similar mechanisms
          transmitted by web browsers.
        </li>
        <li>
          <b>Cookies and Interest-Based Advertising.</b> You may stop or
          restrict the placement of Technologies on your device or remove them
          by adjusting your preferences as your browser or device permits.
          However, if you adjust your preferences, our Services may not work
          properly.
        </li>
      </ul>
      <p>
        Please note that cookie-based opt-outs are not effective on mobile
        applications. However, you may opt-out of personalized advertisements on
        some mobile applications by following the instructions for Android, iOS,
        and others.
      </p>
      <p>
        Please note you must separately opt out in each browser and on each
        device.
      </p>
      <p>
        <b>Your Privacy Rights.</b> In accordance with applicable law, you may
        have the right to:
      </p>
      <ul>
        <li>
          <b>Access Personal Information</b> about you, including: (i)
          confirming whether we are processing your personal information; (ii)
          obtaining access to or a copy of your personal information;
        </li>
        <li>
          <b>Request Correction</b> of your personal information where it is
          inaccurate, incomplete or outdated. In some cases, we may provide
          self-service tools that enable you to update your personal
          information;
        </li>
        <li>
          <b>Request Deletion, Anonymization or Blocking</b> of your personal
          information when processing is based on your consent or when
          processing is unnecessary, excessive or non-compliant;
        </li>
        <li>
          <b>Request Restriction of or Object</b> to our processing of your
          personal information when processing is non-compliant;{" "}
        </li>
        <li>
          <b>Withdraw your Consent</b> to our processing of your personal
          information. If you refrain from providing personal information or
          withdraw your consent to processing, some features of our Service may
          not be available;
        </li>
        <li>
          <b>
            Request data portability and receive an electronic copy of personal
            information that you have provided to us;
          </b>
        </li>
        <li>
          <b>Be informed</b> about third parties with which your personal
          information has been shared; and{" "}
          <b>
            Request the review of decisions taken exclusively based on automated
            processing
          </b>{" "}
          if these decisions could affect your data subject rights.
        </li>
      </ul>

      <h4>6. SECURITY OF YOUR INFORMATION</h4>
      <p>
        We take steps to ensure that your information is treated securely and in
        accordance with this Privacy Policy. Unfortunately, no system is 100%
        secure, and we cannot ensure or warrant the security of any information
        you provide to us. We have taken appropriate safeguards to require that
        your personal information will remain protected, and take steps to
        require our third-party service providers and partners to have
        appropriate safeguards as well. To the fullest extent permitted by
        applicable law, we do not accept liability for unauthorized disclosure.
      </p>
      <p>
        By using our Services or providing personal information to us, you agree
        that we may communicate with you electronically regarding security,
        privacy, and administrative issues relating to your use of our Services.
        If we learn of a security system’s breach, we may attempt to notify you
        electronically by posting a notice on our Services, by mail, or by
        sending an email to you.
      </p>

      <h4>7. INTERNATIONAL DATA TRANSFERS</h4>
      <p>
        Due to the international nature of our business, your personal data may
        be transferred to jurisdictions that do not offer equivalent protection
        of personal data as under the legislation contemplated in this Privacy
        Policy. In such cases, we will process personal data or procure that it
        be processed in accordance with the requirements contemplated within
        this Privacy Policy, which may include having appropriate contractual
        undertakings in legal agreements with service providers who process
        personal data on our behalf.
      </p>
      <p>
        All information processed by us may be transferred, processed, and
        stored anywhere in the world, including, but not limited to, countries
        which may have data protection laws that are different from the laws
        where you live. We endeavour to safeguard your information consistent
        with the requirements of applicable laws.
      </p>

      <h4>8. RETENTION OF PERSONAL INFORMATION</h4>
      <p>
        We store the personal information we collect as described in this
        Privacy Policy for as long as you use our Services, or as necessary to
        fulfill the purpose(s) for which it was collected, provide our Services,
        resolve disputes, establish legal defences, conduct audits, pursue
        legitimate business purposes, enforce our agreements, and comply with
        applicable laws. We will generally retain your personal data throughout
        the lifecycle of the Services you are involved in. Some personal data
        will be retained after your relationship with us ends. We expect to
        delete your personal data (at the latest) once there is no longer any
        legal or regulatory requirement or legitimate business purpose for
        retaining your personal data.
      </p>

      <h4>9. AUTOMATED DECISION-MAKING</h4>
      <p>
        We will not take decisions producing legal effects concerning you, or
        otherwise significantly affecting you, based solely on automated
        processing of your personal data, unless we have considered the proposed
        processing in a particular case and concluded in writing that it meets
        the applicable requirements under applicable legislation.
      </p>

      <h4>10. RIGHTS OF USERS FROM THE EEA AND UK.</h4>
      <p>
        If you are a resident of the UK, European Union, or EEA, you may have
        certain data protection rights. <b>“GDPR”</b> means the European Union
        General Data Protection Regulation (EU) 2016/679, and the United Kingdom
        Data Protection Act 2018. Information that you provide may be
        transferred or accessed by entities around the world as described in
        this Privacy Policy. If you are located in the EEA or UK, you freely
        consent to the transfer of personal information outside of the EEA and
        UK. Your consent to this Privacy Policy together with your submission of
        personal information constitute your agreement to these transfers.
      </p>
      <p>
        <b>Data Controller.</b> For the purposes of this Privacy Policy, Rexla
        Global is the Data Controller of your personal information.
      </p>
      <p>
        <b>Legal Basis.</b> Our legal bases for processing your personal
        information as described in this Privacy Policy are listed below:
      </p>
      <ul>
        <li>
          Contractual Necessity: When needed to perform a contract, we are about
          to enter into or have entered into with you.
        </li>
        <li>
          Legitimate Interests: Where it is necessary for our legitimate
          interests and your interests and fundamental rights do not override
          those interests. This may specifically involve research and
          development, direct marketing, personalizing your user experience, or
          creating aggregated, de-identified and/or anonymized data.
        </li>
        <li>
          Compliance with Law: Where we need to comply with a legal or
          regulatory obligation.
        </li>
        <li>
          Consent: Where we have your specific consent to carry out the
          processing for the purpose in question.
        </li>
      </ul>
      <p>
        <b>Rights of EEA and UK Residents.</b> If you are accessing or using the
        Services from within the EEA or UK, you may have the following rights
        under the GDPR (as well as other rights). If you wish to exercise any of
        these rights, you may do so by contacting us as provided in this Privacy
        Policy.
      </p>
      <ul>
        <li>
          Right of Access: You have the right to obtain confirmation from us as
          to whether or not we process personal information from you and you
          also have the right to at any time obtain access to your personal
          information stored by us.
        </li>
        <li>
          Right to Correction of your Personal Information: If we process your
          personal information, we use reasonable measures to ensure that your
          personal information is accurate and up-to-date for the purposes for
          which your personal information was collected. If your personal
          information is inaccurate or incomplete, you have the right to require
          us to correct it.
        </li>
        <li>
          Right to Deletion of your Personal Information or Right to Restriction
          of Processing: You may have the right to require us to delete your
          personal information or to restrict processing of your personal
          information.
        </li>
        <li>
          Right to Withdraw your Consent: If you have given your consent to the
          processing of your personal information, you have the right to
          withdraw your consent at any time, without affecting the lawfulness of
          processing based on the consent before the withdrawal.
        </li>
        <li>
          Right to Data Portability: You may have the right to receive the
          personal information concerning you and which you have provided to us,
          in a structured, commonly used and machine-readable format or to
          transmit this data to another controller.
        </li>
        <li>
          Right to Object: You may have the right to object to the processing of
          your personal information as further specified in this Privacy Policy.
        </li>
        <li>
          Right to Lodge a Complaint with Supervisory Authority: You have the
          right to lodge a complaint with a data protection supervisory
          authority located in the European Union or UK. Further information
          about how to contact your local data protection authority is available
          at the website of the European Commission.
        </li>
      </ul>
      <h6>Data Processing outside Europe</h6>
      <p>
        We are a business with a presence in several countries globally, and
        many of our service providers, advisers, partners or other recipients of
        data are also based outside the EEA and U.K. This means that, if you use
        our Services, your personal information will necessarily be accessed and
        processed outside of the EEA and U.K.
      </p>
      <p>
        Where we share your personal information with third parties who are
        based outside Europe, we try to ensure a similar degree of protection is
        afforded to it by making sure one of the following mechanisms is
        implemented:
      </p>

      <ul>
        <li>
          Transfers to territories with an adequacy decision. We may transfer
          your personal information to countries or territories whose laws have
          been deemed to provide an adequate level of protection for personal
          information by the European Commission or UK Government (as and where
          applicable) (from time to time).
        </li>
        <li>
          Transfers to territories without an adequacy decision.
          <p>
            o We may transfer your personal information to countries or
            territories whose laws have not been deemed to provide such an
            adequate level of protection.
          </p>
          <p>However, in these cases:</p>
          <p>
            o we may use specific appropriate safeguards, which are designed to
            give personal information effectively the same protection it has in
            Europe – for example, standard-form contracts approved by relevant
            authorize for this purpose; or
          </p>
          <p>
            o in limited circumstances, we may rely on an exception, or
            ‘derogation’, which permits us to transfer your personal information
            to such country despite the absence of an ‘adequacy decision’ or
            ‘appropriate safeguards’ – for example, reliance on your explicit
            consent to that transfer.
          </p>
        </li>
      </ul>
      <p>
        If you would like to exercise any of these rights, please contact us as
        set forth in “Contact Us” below. We will process such requests in
        accordance with applicable laws.
      </p>

      <h4>11. CHILDREN’S INFORMATION</h4>
      <p>
        The Services are not directed to children under 18 (or other age as
        required by local law), and we do not knowingly collect personal
        information from children. If you are a parent or guardian and believe
        your child has uploaded personal information to our site without your
        consent, you may contact us as described in “Contact Us” below. If we
        become aware that a child has provided us with personal information in
        violation of applicable law, we will delete any personal information we
        have collected, unless we have a legal obligation to keep it, and
        terminate the child’s account if applicable.
      </p>

      <h4>12. OTHER PROVISIONS</h4>
      <p>
        <b>Third-Party Websites/Applications.</b> The Services may contain links
        to other websites/applications and other websites/applications may
        reference or link to our Services. These third-party services are not
        controlled by us. We encourage our users to read the privacy policies of
        each website and application with which they interact. We do not
        endorse, screen, or approve, and are not responsible for, the privacy
        practices or content of such other websites or applications. Providing
        personal information to third-party websites or applications is at your
        own risk. Supervisory Authority. If you are located in the EEA,
        Switzerland, the UK, India, China, or Brazil, you have the right to
        lodge a complaint with a supervisory authority if you believe our
        processing of your personal information violates applicable law.
      </p>
      <p>
        <b>Changes to our Privacy Policy.</b> We may revise this Privacy Policy
        from time to time at our sole discretion. If there are any material
        changes to this Privacy Policy, we will notify you as required by
        applicable law. You understand and agree that you will be deemed to have
        accepted the updated Privacy Policy if you continue to use our Services
        after the new Privacy Policy takes effect.
      </p>
      <p>
        <b>Refer-a-Friend and Similar Incentive Programs.</b> As described above
        in “How We Use Your Personal Information”, we may offer referral
        programs or other incentivized data collection programs. For example, we
        may offer incentives to you such as discounts or promotional items or
        credit in connection with these programs, wherein you provide your
        personal information in exchange for a reward, or provide personal
        information regarding your friends or colleagues (such as their email
        address) and receive rewards when they sign up to use our Services. (The
        referred party may also receive rewards for signing up via your
        referral.) These programs are entirely voluntary and allow us to grow
        our business and provide additional benefits to you. The value of your
        data to us depends on how you ultimately use our Services, whereas the
        value of the referred party’s data to us depends on whether the referred
        party ultimately becomes a user and uses our Services. Said value will
        be reflected in the incentive offered in connection with each program.
      </p>

      <h4>13. CONTACT US</h4>
      <p>
        If you have any questions about our privacy practices or this Privacy
        Policy, or to exercise your rights as detailed in this Privacy Policy,
        please contact us at{" "}
      </p>
      <p>Rexla Global L.L.C - FZ</p>
      <p>
        Business Center 1, M Floor, The Meydan Hotel, Nad Al Sheba, Dubai, U.A.E
      </p>
      <p>United Arab Emirates</p>
      <p>
        Website:{" "}
        <a href="https://rexlaglobal.com" target="_blank" rel="noreffer">
          https://rexlaglobal.com
        </a>
      </p>

      <p>
        Email: <a href="mailto:compliance@Rexla.com">compliance@Rexla.com</a>
      </p>
      <p>Phone number: +971588427362</p>

      <h4>
        14. If you are not satisfied with the way in which we handle (a
        complaint about) the processing of your personal data, you have the
        right to submit a complaint to the Information Commissioner's Office in
        the first instance go to{" "}
        <a
          href="https://ico.org.uk/make-a-complaint/"
          target="_blank"
          rel="noreffer"
        >
          https://ico.org.uk/make-a-complaint/
        </a>
      </h4>

      <h4>15. Amendments to this privacy statement</h4>
      <p>
        We reserve the right to make amendments to this privacy statement. It is
        recommended that you consult this privacy statement regularly in order
        to be aware of any changes. In addition, we will actively inform you
        wherever possible.
      </p>
    </div>
  );
};
export default Privacy;
